export default __webpack_public_path__ + "static/media/delete_darkGreen.4212722a.svg";